import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface AuthLayoutProps {
  children: ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left panel */}
      <div className="hidden lg:flex w-1/2 bg-primary-500 flex-col items-center justify-center overflow-hidden px-16">
        {/* Logo */}
        <Link to="/" className="flex items-center mb-10">
          <img src="/logo.png" alt="ARYA" className="h-12 brightness-0 invert" />
        </Link>

        {/* Heading */}
        <h1 className="font-display font-black text-4xl text-white uppercase leading-tight text-center mb-6">
          ОЮУН МЭДЛЭГИЙН АЯЛЛАА ӨНӨӨДӨР ЭХЛҮҮЛЬЕ
        </h1>

        {/* Description */}
        <p className="text-lg text-white/80 text-center mb-8 max-w-md">
          Мянга мянган суралцагчдын нэг болж, шилдэг багш нараас суралцаж,
          өөрийгөө хөгжүүлээрэй.
        </p>

        {/* Bullet list */}
        <ul className="list-disc list-inside space-y-2 text-sm text-white">
          <li>Насан туршийн эрх</li>
          <li>30+ Шилдэг багш нар</li>
          <li>120+ Мэргэжлийн сургалт</li>
        </ul>
      </div>

      {/* Mobile header */}
      <div className="lg:hidden bg-primary-500 px-6 py-8 text-center">
        <Link to="/" className="inline-flex items-center mb-4">
          <img src="/logo.png" alt="ARYA" className="h-10 brightness-0 invert" />
        </Link>
        <h1 className="font-display font-black text-xl text-white uppercase leading-tight">
          ОЮУН МЭДЛЭГИЙН АЯЛЛАА ӨНӨӨДӨР ЭХЛҮҮЛЬЕ
        </h1>
      </div>

      {/* Right panel */}
      <div className="flex-1 bg-gray-50 flex items-center justify-center px-4 sm:px-10 py-8 lg:py-0">
        {children}
      </div>
    </div>
  )
}
